export default {
  add: "Hinzufügen",
  addNorm: "+Norm (1.06 - 1.09) hinzufügen",
  addSimulationSoftware: "+Simulationssoftware hinzufügen",
  apply: "Anwenden",
  approve: "Genehmigen",
  // assign: "Zuordnen",
  // attributeSets: "Attribut Sets",
  back: "Zurück",
  cancel: "Abbrechen",
  // change: "Ändern",
  close: "Schließen",
  collapse: "Alle einklappen",
  confirm: "Bestätigen",
  // continue: "Fortsetzen",F
  create: "Erstellen",
  // createdBy: "created by",
  databaseAccess: "Einheiten & Zertifikate",
  delete: "Löschen",
  deny: "Ablehnen",
  discard: "Verwerfen",
  // done: "Fertig",
  // download: "Download",
  // edit: "Berbeiten",
  editName: "Namen bearbeiten",

  changePassword: "Passwort ändern",
  discardErrorReportButtonLabel: "Fehlerbericht verwerfen",
  errorReportButtonLabel: "Fehler melden",
  expand: "Alle ausklappen",
  // filters: "Filter",
  goBack: "Zurück",
  // hide: "Zugehörige Assets ausblenden",
  homePage: "Startseite",
  logIn: "Anmelden",
  logOut: "Abmelden",
  new: "Neu",
  // newLog: " Neuer Log",
  // next: "Weiter",
  no: "Nein",
  continue: "Weiter",
  // OK: "OK",
  refreshTable: "Tabelle aktualisieren",
  reload: "Neu laden",
  remove: "Entfernen",
  // replace: "Ersetzen",
  // reserve: "Reservieren",
  reset: "Zurücksetzen",
  resetAllFilters: "Alle Filter zurücksetzen",
  revoke: "Widerrufen",
  // run: "Ausführen",
  save: "Speichern",
  saveChanges: "Änderungen speichern",
  // send: "Senden",
  sendInvite: "Einladung senden",
  // settings: "Einstellungen",
  // show: "Zugehörige Assets anzeigen",
  showFullText: "Vollständigen Text anzeigen",
  sort: "Sortierung",
  submit: "Absenden",
  // unassign: "Abwählen",
  undoChanges: "Änderungen rückgängig machen",
  // unselect: "Abwählen",
  uploadGridConnectionValues: "Liste der Netzanschlusswerte hochladen",
  yes: "Ja",
  linkToHome: "Link zur Startseite",
  linkTo: "Link zu",
  subscribe: "Abonnieren",
  unsubscribe: "Abbestellen",

  showRoleDescription: "Rollenbeschreibung anzeigen",
};
